<template>
  <div class="content">
    <div class="title" style="margin-bottom: 16px;">代理商信息：{{title}}</div>
    <el-form :model="queryParams" ref="queryForm"  :inline="true">
      <el-form-item prop="productName">
        <el-input
          v-model="queryParams.productName"
          placeholder="请输入套餐名称"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="ratioSchemeAdd"
          v-hasPermi="['agent:customProduct:save']"
        >新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          icon="el-icon-close"
          @click="handleClose"
        >关闭</el-button>
      </el-col>
    </el-row>

    <el-table v-loading="loading" border :data="schemeList" >
      <el-table-column label="方案ID" prop="id" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="方案名称" prop="name" min-width="160" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="套餐信息" align="center" min-width="500px">
          <template slot-scope="scope">
            <el-descriptions :column="2" :colon="false"  >
             <template v-for="(item,index) in scope.row.productList" >
                <el-descriptions-item :key="index">【{{item.productId}}】【{{item.productName}}】【{{item.type}}】</el-descriptions-item>
                <el-descriptions-item :key="index">
                  <el-tag style="margin-right: 5px;" size="small" v-for="(price,index) in item.priceItems" :key="index">{{price.operationName}}:{{price.price}}元</el-tag>
                </el-descriptions-item>
             </template>
          </el-descriptions>
          </template>
      </el-table-column>
      <el-table-column label="卡数" prop="source" align="center" :show-overflow-tooltip="true" >
        <template slot-scope="scope">
            <el-link type="primary" @click="openCardListDialog(scope.row)">{{scope.row.cardNum}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="130" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-circle-close"
            @click="handleRemove(scope.row)"
          >删除</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="openEditPriceDialog(scope.row)"
          >修改</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-plus"
            @click="openAddCardDialog(scope.row)"
          >加卡</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增卡列表对话框 -->
    <el-dialog
      :title="cardListTitle"
      :visible.sync="cardListDialogVisible"
      width="80%"
      :before-close="handleCardListDialogClose"
    >
      <el-form :model="cardQueryParams" ref="cardQueryForm" :inline="true">
        <el-form-item prop="iccids">
          <el-input
            v-model="cardQueryParams.iccids"
            placeholder="批量卡号"
            clearable
            style="width: 240px"
            @keyup.enter.native="handleCardQuery"
          />
        </el-form-item>
        <el-form-item prop="startIccid">
          <el-input
            v-model="cardQueryParams.startIccid"
            placeholder="开始卡号"
            clearable
            style="width: 240px"
            @keyup.enter.native="handleCardQuery"
          />
        </el-form-item>
        <el-form-item prop="endIccid">
          <el-input
            v-model="cardQueryParams.endIccid"
            placeholder="结束卡号"
            clearable
            style="width: 240px"
            @keyup.enter.native="handleCardQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleCardQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetCardQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-search" @click="handleBatchRemove">批量移除</el-button>
        </el-form-item>
      </el-form>
      
      <div style="margin-bottom: 8px; color: #606266;">
        已选中 <span style="color: red;">{{ selectedCardIds.length }}</span> 条
      </div>
      <el-table
        ref="cardTable"
        v-loading="cardLoading"
        border
        :data="cardList"
        row-key="iccid"
        @selection-change="handleSelectionCard"
      >
        <el-table-column type="selection" width="55" align="center" reserve-selection></el-table-column>
        <el-table-column label="ICCID" prop="iccid" align="center" :show-overflow-tooltip="true" />
        <el-table-column label="MSISDN" prop="msisdn" align="center" :show-overflow-tooltip="true" />
        <el-table-column label="状态" prop="showStatus" align="center" :show-overflow-tooltip="true" />
        <el-table-column label="创建时间" prop="createTime" align="center" :show-overflow-tooltip="true" />
      </el-table>
      
      <pagination
        v-show="cardTotal>0"
        :total="cardTotal"
        :page.sync="cardPageNum"
        :limit.sync="cardPageSize"
        @pagination="getCardList"
      />
    </el-dialog>
    <el-dialog title="添加卡片"
      :visible.sync="addCardDialogVisible"
      width="800px"
      :before-close="closeAddCardDialog"
      :close-on-click-modal="false">
      <el-form :model="cardSchemeForm">
        <el-form-item label="方案名称">
          <span>{{cardSchemeForm.name}}</span>
        </el-form-item>
        <el-form-item label="上传模式" prop="fieldType" >
          <el-radio-group v-model="cardSchemeForm.fieldType" @input="switchFieldType">
            <el-radio  label="1" >批量ICCIDS</el-radio>
            <el-radio  label="2" >ICCID号段</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="ICCID列表" prop="iccids" v-if="cardSchemeForm.fieldType == '1'">
          <el-input
            v-model="cardSchemeForm.iccids"
            type="textarea"
            :placeholder="'以回车键分割ICCID\n'"
            rows="8"
            style="width:420px;font-size:14px"
            @input="handleCardSum"
          ></el-input>
        </el-form-item>
        <el-form-item label="ICCID范围" prop="startIccid" v-if="cardSchemeForm.fieldType == '2'">
          <el-input
            v-model="cardSchemeForm.startIccid"
            style="width: 230px;margin-right: 10px;"
            placeholder="包含开始值"
            clearable
          ></el-input>
          <span>-</span>
          <el-input
            v-model="cardSchemeForm.endIccid"
            style="width: 230px;margin-left: 10px;"
            placeholder="包含终止值"
            clearable
          ></el-input>
          <el-button style="margin-left:10px" type="primary" @click="handleCardSum">统计</el-button>
        </el-form-item>
        <el-form-item>
          <span style="top: -2px;color: #666;">已选择<em style="color:red">{{number}}</em>条</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAddCardDialog">取消</el-button>
        <el-button type="primary" @click="confirmAddCard">确认</el-button>
      </div>
    </el-dialog>
    <!-- 价格编辑对话框 -->
    <el-dialog
      :title="editPriceTitle"
      :visible.sync="editPriceDialogVisible"
      width="1200px"
      :before-close="closeEditPriceDialog"
      :close-on-click-modal="false"
    >
      <el-form :model="schemeForm" ref="priceForm" label-width="80px">
        <el-button type="primary" icon="el-icon-plus" @click="handleAddProduct">添加套餐</el-button>
        <!-- 原有表单项替换为表格 -->
        <el-table :data="schemeForm.services" border style="width: 100%">
          <el-table-column label="套餐名称" prop="productName" align="center">
            <template slot-scope="scope">
              【{{scope.row.id}}】{{scope.row.productName}}
            </template>
          </el-table-column>
          <el-table-column label="电信" align="center">
            <template slot-scope="scope">
              <el-input v-model="getPriceItem(scope.row,'中国电信').price" type="number" placeholder="请输入价格"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="移动" align="center">
            <template slot-scope="scope">
              <el-input v-model="getPriceItem(scope.row,'中国移动').price" type="number" placeholder="请输入价格"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="联通" align="center">
            <template slot-scope="scope">
              <el-input v-model="getPriceItem(scope.row,'中国联通').price" type="number" placeholder="请输入价格"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="text" icon="el-icon-circle-close" @click="deleteProduct(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeEditPriceDialog">取消</el-button>
        <el-button type="primary" @click="handleEditPrice">确认</el-button>
      </div>
    </el-dialog>
    <!-- 添加套餐对话框 -->
    <el-dialog title="添加套餐" :visible.sync="addPriceDialogVisible" width="1200px" append-to-body :close-on-click-modal="false">
			<el-form :model="productForm" ref="productForm" :inline="true">
				<el-form-item label="套餐名称">
					<el-input v-model="productForm.productName" placeholder="请输入套餐名称" clearable
						style="width: 200px;margin-right: 20px;" />
				</el-form-item>
				<el-form-item label="套餐类型">
					<el-select style="width:160px" v-model="productForm.productTypes" multiple filterable clearable placeholder="请选择">
						<el-option v-for="dict in productTypes" :key="dict.key" :label="dict.value"
							:value="dict.key">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="productDataPage">搜索</el-button>
				</el-form-item>
			</el-form>
      <div style="margin: 15px 0; color: #606266;">
          已选套餐：<span style="color: red;">{{ selectionProduct.length }}</span>个
      </div>
      <el-table :data="productData" height="500" @selection-change="handleSelectionProductChange">
        <el-table-column type="selection" align="center" width="60px"></el-table-column>
        <el-table-column prop="id" label="套餐编号" align="center"></el-table-column>
        <el-table-column prop="productName" label="套餐名称" align="center"></el-table-column>
        <el-table-column prop="productType" label="套餐类型" align="center" ></el-table-column>
        <el-table-column prop="flowCount" label="流量" align="center"></el-table-column>
        <el-table-column prop="showFlowCount" label="展示流量" align="center" ></el-table-column>
      </el-table>
      <pagination v-show="productTotal>0" :total="productTotal" :page-sizes="[10, 20, 30, 40]" :page-size="productForm.pageSize" :page.sync="productForm.page"
          :limit.sync="productForm.pageSize" @pagination="productDataPage" />
			<div class="dialog-footer" slot="footer">
				<el-button  type="primary" plain @click="confirmAddProduct">确定</el-button>
			</div>
		</el-dialog>
  </div>
</template>

<script>
import {agentDetail, selectRatioSchemeList ,productPage ,updateRatioSchemeProduct,selectCount,updateRatioSchemeCard , pageCards , deleteRatioSchemeCard , deleteRatioScheme } from "@/api/api";


export default {
  data() {
    return {
      title: "",
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 代理商套餐表格数据
      schemeList: [],
      // 查询参数
      queryParams: {
        userId: undefined,
        productName: undefined
      },
      // 卡列表对话框相关数据
      cardListTitle: '卡片列表',
      cardListDialogVisible: false,
      currentProduct: {},
      cardLoading: false,
      cardTotal: 0,
      cardList: [],
      cardPageNum: 1,
      cardPageSize: 10,
      cardQueryParams: {
        schemeId: undefined,
        iccids: undefined,
        startIccid: undefined,
        endIccid: undefined
      },
      // 价格编辑对话框相关数据
      editPriceTitle: '修改价格',
      editPriceDialogVisible: false,
      editedPrices: [],
      schemeForm:{
        schemeId: undefined,
        services:[]
      },
      // 添加套餐对话框相关数据
      addPriceDialogVisible: false,
      productTypes:[
        {key:'1',value:'累计套餐'},
        {key:'2',value:'月套餐'},
        {key:'3',value:'加油包'},
      ],
      productTotal:0,
      productForm:{
        productName:undefined,
        productTypes:[],
        type:'1',
        page:1,
        pageSize:10
      },
      productData:[],
      selectionProduct:[],
      selectionCards:[],
      selectedCardIds: [],
      cardSchemeForm:{
        name:undefined,
        schemeId: undefined,
        iccids:undefined,
        startIccid:undefined,
        endIccid:undefined,
        fieldType:'1',
      },
      addCardDialogVisible:false,
      number:0,
    };
  },
  watch: {
    // 监听路由中userId参数变化
    '$route.params.userId'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        sessionStorage.setItem('agentProduct', newVal);
        this.queryParams.userId = newVal;
        this.resetQuery(); // 重置搜索条件
        this.initAgentDetail();
      }
    }
  },
  created() {
    const userId = this.$route.params && this.$route.params.userId;
    if (userId) {
      sessionStorage.setItem('agentProduct', userId);
      this.queryParams.userId = userId;
      this.getList();
    }else{
      this.queryParams.userId = sessionStorage.getItem('agentProduct');
      this.getList();
    }
    this.initAgentDetail();
  },
  methods: {
    // 获取数据
    initAgentDetail(){
      agentDetail({userId : this.queryParams.userId}).then(res=>{
        let username = res.data.data.agent.username;
        let company = res.data.data.agent.companyName;
        this.title = "[" + username + "]" + company;
      });
    },
    /** 查询代理商套餐列表 */
    getList() {
      this.loading = true
      selectRatioSchemeList(this.queryParams).then(res => {
        this.schemeList = res.data.data || [];
        this.loading = false;
      });
    },
    // 返回按钮
    handleClose() {
      const obj = { path: "/partners/agent" };
      this.$tab.closeOpenPage(obj);
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    ratioSchemeAdd(){
      this.$router.push({path:"/scheme/ratio/add/"+this.queryParams.userId});
    },
    getPriceItem(item,operatorName){
      return item.products.find(price => price.operatorName == operatorName)|| { price: 0 };
    },
    // 查询套餐列表
    productDataPage(){
      let productTypes = this.productForm.productTypes.length == 0?["1","2","3"] : this.productForm.productTypes
      let params = {
        model:{
          ...this.productForm,
          productTypes:productTypes
        },
        page: this.productForm.page,
        pageSize: this.productForm.pageSize,
      };
      productPage(params).then(res => {
        this.productData = res.data.data.records;
        this.productTotal = res.data.data.total;
        this.productData.forEach(item => {
          item.flowCount = this.formatFlow(item.flowCount);
          item.showFlowCount = this.formatFlow(item.showFlowCount);
          item.status = this.transferIsDisable(item.status);
        })
      });
    },
    // 流量转换
    formatFlow(flow){
      if(!flow){
        return null;
      }
      if(0 > flow){
        flow = "畅享";
      }else if(1024 > flow > 0){
        flow = flow + 'M';
      }else if(flow >= 1024){
        flow = (flow/1024).toFixed(2) + 'G';
      }
      return flow;
    },
    // 状态转换
    transferIsDisable(status) {
      let obj = {
        0: "未启用",
        1: "启用中"
      };
      return obj[status];
    },
    handleSelectionCard(cards){
      this.selectionCards = cards
      this.selectedCardIds = cards.map(item => item.iccid)
    },
    // 添加套餐
    handleAddProduct(){
      this.addPriceDialogVisible = true;
      this.productDataPage();
    },
    handleSelectionProductChange(products){
      this.selectionProduct = products
    },
    confirmAddProduct(){
      this.addPriceDialogVisible = false
      let scs = this.schemeForm.services.map(m=>m.id.toString())
      let products = this.selectionProduct.filter(item=>!scs.includes(item.id.toString()))
        .map(item=>({
          id:item.id,
          productName:item.productName,
          type:item.productType,
          products:item.products.map(price=>({
            price:price.price,
            operatorName:price.operatorName
          }))
      }))
      this.schemeForm.services.push(...products)
    },
    deleteProduct(row){
      let services = this.schemeForm.services;
      for (let i = services.length - 1; i >= 0; i--) {
        if (services[i].id === row.id) {
          services.splice(i, 1);
        }
      }
    },
    // 添加卡片
    openAddCardDialog(row){
      this.cardSchemeForm.name = row.name;
      this.cardSchemeForm.schemeId = row.id;
      this.cardSchemeForm.fieldType = "1"
      this.cardSchemeForm.iccids = ""
      this.cardSchemeForm.startIccid = ""
      this.cardSchemeForm.endIccid = ""
      this.number = 0
      this.addCardDialogVisible = true;
    },
    closeAddCardDialog(){
      this.addCardDialogVisible = false;
    },
    switchFieldType(){
      this.handleCardSum()
    },
    handleCardSum(){
      if(this.cardSchemeForm.fieldType == '2'){
        if(!this.cardSchemeForm.startIccid || !this.cardSchemeForm.endIccid){
          this.number = 0
          return 
        }
        let startIccid = this.cardSchemeForm.startIccid.replace(/\s+/g, '');
        let endIccid = this.cardSchemeForm.endIccid.replace(/\s+/g, '');
        if(!startIccid || !endIccid){
          this.number = 0
          return 
        }
        selectCount({startIccid,endIccid}).then(res=>{
          this.number = res.data.data
        })
        return
      }
      let iccids = this.cardSchemeForm.iccids ? this.cardSchemeForm.iccids.split("\n"):[];
      this.number = iccids.filter(item=>!!item).length
    },
    confirmAddCard(){
      if(this.number == 0){
        this.$modal.msgError("请输入ICCIDS或者输入ICCID范围");
        return 
      }
      let params = {
        ...this.cardSchemeForm,
        iccids:!!this.cardSchemeForm.iccids ? this.cardSchemeForm.iccids.split("\n") : []
      };
      updateRatioSchemeCard(params).then(res=>{
        this.closeAddCardDialog()
        this.$modal.msgSuccess("添加成功");
        this.getList();
      })
    },
    /** 打开卡列表对话框 */
    openCardListDialog(row) {
      this.cardListTitle = '卡片列表-'+row.name
      this.cardQueryParams.schemeId = row.id;
      this.cardListDialogVisible = true;
      this.getCardList();
    },
    /** 关闭卡列表对话框 */
    handleCardListDialogClose() {
      this.cardListDialogVisible = false;
      this.resetForm("cardQueryForm");
      this.selectionCards = [];
      this.selectedCardIds = [];
      if (this.$refs.cardTable) {
        this.$refs.cardTable.clearSelection();
      }
    },
    /** 查询卡列表 */
    getCardList() {
      this.cardLoading = true;
      let params = {
        model:{
          ...this.cardQueryParams,
          iccids:!!this.cardQueryParams.iccids ? this.cardQueryParams.iccids.split(/\s+/) : []
        },
        page:this.cardPageNum,
        pageSize:this.cardPageSize
      }
      pageCards(params).then(res=>{
        this.cardLoading = false;
        this.cardTotal = res.data.data.total;
        this.cardList = res.data.data.records
      })
      
    },
    /** 搜索卡列表 */
    handleCardQuery() {
      this.cardPageNum = 1;
      this.getCardList();
    },
    /** 重置卡列表搜索 */
    resetCardQuery() {
      this.resetForm("cardQueryForm");
      this.handleCardQuery();
    },
    /** 价格编辑对话框 */
    openEditPriceDialog(row) {
      this.editPriceTitle = '修改价格-'+row.name

      this.schemeForm.schemeId = row.id;
      this.schemeForm.services = row.productList.map(item=>({
        id:item.productId,
        productName:item.productName,
        type:item.productType,
        products:item.priceItems.map(price=>({
          price:price.price,
          operatorName:price.operationName
        }))
      }))
      // 初始化编辑价格数据为数组
      this.editPriceDialogVisible = true;
    },
    /** 处理价格修改 */
    handleEditPrice() {
      if(this.schemeForm.services.length == 0){
        this.$modal.msgError("请添加套餐");
        return 
      }
      let arrShow = true;
      let msg = "运营商价格不能小于0";
      this.schemeForm.services.forEach(item=>{
        item.products.forEach(product=>{
          if(!product.price || product.price <= 0){
            arrShow = false
            msg="运营商价格不能小于0";
            return 
          }
        })
      })
      if(!arrShow){
        this.$modal.msgError(msg);
        return 
      }
      updateRatioSchemeProduct(this.schemeForm).then(res=>{
        this.$modal.msgSuccess("更新成功");
        this.getList()
        this.closeEditPriceDialog()
        this.schemeForm = {schemeId : undefined,services:[]}
      })
    },
    /** 关闭价格编辑对话框 */
    closeEditPriceDialog() {
      this.editPriceDialogVisible = false;
    },
    handleBatchRemove(){
      if(this.selectionCards.length == 0){
        this.$modal.msgError("请选择要移除的卡片");
        return 
      }
      let params = {
        schemeId : this.cardQueryParams.schemeId,
        iccids:this.selectionCards.map(item=>item.iccid)
      }
      deleteRatioSchemeCard(params).then(res=>{
        this.$modal.msgSuccess("移除成功");
        this.getList()
        this.handleCardListDialogClose()
        this.selectionCards = []
      })
    },
    handleRemove(row){
      this.$modal.confirm('确认删除方案【'+row.name+'】吗？').then(() => {
        let params = {
          id : row.id
        }
        deleteRatioScheme(params).then(res=>{
          this.$modal.msgSuccess("移除成功");
          this.getList()
        })
      });
    }
  }
};
</script>